
import { IonItem, IonLabel, IonList } from '@ionic/react'
import React from 'react'
import Page from '../components/Page'

let kbslist = [

    {
        kuerzel: "AG",
        name: "Aargau",
        wappen: "wappen/ag.gif",
        link: "https://www.ag.ch/geoportal/apps/onlinekarten/?basemap=base_landeskarten_farbig::topicmaps.geo.ag.ch,0.6,true&center=2655859.48,1249736.83&z=3&layers=ch_ag_geo_afu_kbs_01::wms.geo.ag.ch;1;true"
    },
    {
        kuerzel: "AI",
        name: "Appenzell Innerrhoden",
        wappen: "wappen/ai.gif",
        link: "https://www.geoportal.ch/ch/map/252?y=2747342.01&x=1244624.34&scale=100000&rotation=0",
        notes: ""
    },
    {
        kuerzel: "AR",
        name: "Appenzell Ausserrhoden",
        wappen: "wappen/ar.gif",
        link: "https://www.geoportal.ch/ch/map/252?y=2745432.62&x=1252652.23&scale=10000&rotation=0",
        notes: ""
    },
    {
        kuerzel: "BL",
        name: "Basel-Landschaft",
        wappen: "wappen/bl.gif",
        link: "https://geoview.bl.ch/?map_x=2621744.3974429&map_y=1259205.5204744&map_zoom=4&tree_group_layers_Kataster%20belasteter%20Standorte=kbs_kataster_standorte&tree_groups=Kataster%20belasteter%20Standorte&baselayer_opacity=100&baselayer_ref=grundkarte_sw",
        notes: ""
    },
    {
        kuerzel: "BS",
        name: "Basel-Stadt",
        wappen: "wappen/bs.gif",
        link: "https://map.geo.bs.ch/?lang=de&baselayer_ref=Grundkarte%20farbig&tree_group_layers_Kataster%20der%20belasteten%20Standorte=AK_KatasterDerBelastetenStandorte&tree_group_layers_KBS=AK_KatasterDerBelastetenStandorte&tree_groups=Boulevard%20Innenstadt%2CGastro-Sekund%C3%A4rl%C3%A4rm%2CHundesignalisation%2CKBS%2CL%C3%A4rmkataster%2CRisikokataster%2CSchallpegelmessungen%2CStrassenl%C3%A4rmsanierung%2CTigerm%C3%BCckenbek%C3%A4mpfung&tree_group_layers_Boulevard%20Innenstadt=&tree_group_layers_Gastro-Sekund%C3%A4rl%C3%A4rm=&tree_group_layers_Hundesignalisation=&tree_group_layers_L%C3%A4rmkataster=&tree_group_layers_Risikokataster=&tree_group_layers_Schallpegelmessungen=&tree_group_layers_Strassenl%C3%A4rmsanierung=&tree_enable_TI_Tigermuecke_Bekaempfung=false&tree_enable_TI_Tigermuecke_Bekaempfung_BL=false",
        notes: ""
    },
    {
        kuerzel: "be",
        name: "Bern",
        wappen: "wappen/be.gif",
        link: "https://www.topo.apps.be.ch/pub/map/?lang=de&gpk=BALISKBS_GPK",
        notes: ""
    },
    {
        kuerzel: "fr",
        name: "Freiburg",
        wappen: "wappen/fr.gif",
        link: "https://map.geo.fr.ch/?fileUrl=http%3A//map.geo.fr.ch/kmz/SitesPollues.kmz",
        notes: ""
    },
    {
        kuerzel: "ge",
        name: "Genf",
        wappen: "wappen/ge.gif",
        link: "https://map.sitg.ge.ch/app/?mapresources=GEOLOGIE",
        notes: ""
    },
    {
        kuerzel: "gl",
        name: "Glarus",
        wappen: "wappen/gl.gif",
        link: "https://map.geo.gl.ch/?l=ch.gl.basemaps.kantonsmaske%5B40%5D%2Cch.gl.environmentalprotection.kbs&bl=pixelkarte-grau&t=default&c=2723829%2C1210751&s=20000",
        notes: ""
    },
    {
        kuerzel: "ju",
        name: "Jura",
        wappen: "wappen/ju.gif",
        link: "https://geo.jura.ch/theme/Environnement?lang=fr&tree_group_layers_Point%20d%27interets=POI_Administration%2CPOI_Ecoles%2CPOI_Sante%2CPOI_Service%2Cadresses%2Ccommunes_ju%2Cperimetre_npa%2Ccadastre_troncon_rue_affichage&baselayer_ref=sdt_01_03_mensuration_officielle&baselayer_opacity=0&theme=Environnement&tree_group_layers_Environnement=env_21_14_cadastre_accidents_majeurs%2Csdt_15_07_gaz_naturel_haute_pression%2Csin_21_12_routes_opam%2Cenv_21_14_cadastre_accidents_majeurs_buffer%2Csdt_15_07_gaz_naturel_haute_pression_buffer%2Cenv_05_01_sites_pollues&map_x=2580390&map_y=1238120&map_zoom=1&tree_groups=Environnement",
        notes: ""
    },
    {
        kuerzel: "lu",
        name: "Luzern",
        wappen: "wappen/lu.gif",
        link: "https://map.geo.lu.ch/bodenbelastung/altlasten/",
        notes: ""
    },
    {
        kuerzel: "ne",
        name: "Neuenburg",
        wappen: "wappen/ne.gif",
        link: "https://sitn.ne.ch/theme/canepo?lang=fr&baselayer_ref=blank&tree_group_layers_gp_mo_cadastre_partiel=&tree_group_layers_gp_sites_pollues=en07_canepo_accidents%2Cen07_canepo_entreprises%2Cen07_canepo_entreprises_polygones%2Cen07_canepo_decharges%2Cen07_canepo_decharges_polygones&tree_enable_2-topo=false&map_x=2551009&map_y=1204827&map_zoom=2&tree_groups=gp_mo_cadastre_partiel%2Cgp_sites_pollues%2Cgp_base_layers_canepo",
        notes: ""
    },
    {
        kuerzel: "nw",
        name: "Nidwalden",
        wappen: "wappen/nw.gif",
        link: "https://www.gis-daten.ch/map/nw_kbs",
        notes: ""
    },
    {
        kuerzel: "ow",
        name: "Obwalden",
        wappen: "wappen/ow.gif",
        link: "https://www.gis-daten.ch/map/ow_kbs",
        notes: ""
    },
    {
        kuerzel: "sh",
        name: "Schaffhausen",
        wappen: "wappen/sh.gif",
        link: "https://map.geo.sh.ch/geoportal/legend?project=Geoportal%20Schaffhausen&legend=Legende&rotation=0.00&scale=94506&center=2684328,1287266",
        notes: "KbS muss oben rechts gesucht und angeklickt werden."
    },
    {
        kuerzel: "sz",
        name: "Schwyz",
        wappen: "wappen/sz.gif",
        link: "https://map.geo.sz.ch/?lang=de&baselayer_ref=Landeskarte%20(farbig)&map_x=2699490&map_y=1220194&map_zoom=6&tree_group_layers_grp_Umws_Lae_KbS=ch.bav.kataster-belasteter-standorte-oev%2Cch.bazl.kataster-belasteter-standorte-zivilflugplaetze%2Cch.sz.a020a.kataster_belasteter_standorte_grp&tree_groups=grp_Umws_Lae_KbS&tree_enable_ch.sz.a073b.kbs_oev=true&tree_enable_ch.sz.a072b.kbs_zivile_flugplaetze=true&tree_enable_ch.sz.a076b.kbs_militaer=true&tree_enable_ch.sz.a020b.kataster_belasteter_standorte=true",
        notes: ""
    },
    {
        kuerzel: "so",
        name: "Solothurn",
        wappen: "wappen/so.gif",
        link: "https://geo.so.ch/map/?bl=hintergrundkarte_sw&l=ch.so.afu.altlasten.standorte%5B40%5D%2Cch.so.agi.gemeindegrenzen%21%2Cch.so.afu.fliessgewaesser.netz%5B38%5D%21%2Cch.so.afu.altlasten.standorte%5B40%5D&t=default&c=2621965%2C1241468&s=37795",
        notes: ""
    },
    {
        kuerzel: "sg",
        name: "St. Gallen",
        wappen: "wappen/sg.gif",
        link: "https://www.geoportal.ch/ch/map/252?y=2736166.12&x=1254414.95&scale=25000&rotation=0",
        notes: ""
    },
    {
        kuerzel: "ti",
        name: "Tessin",
        wappen: "wappen/ti.gif",
        link: "https://www.oasi.ti.ch/web/catasti/siti-inquinati.html",
        notes: ""
    },
    {
        kuerzel: "tg",
        name: "Thurgau",
        wappen: "wappen/tg.gif",
        link: "https://map.geo.tg.ch/apps/mf-geoadmin3/?topic=umweltschutz&lang=de&bgLayer=basemap_farbig&layers_opacity=0.9,0.9,0.9,0.9,1,1,1,0.9,0.9&zoom=3.9957333333333334&layers=kbs-kbs_parzelle,av_wms_resf,av_wms_osbp,kbs-kbs_standort,kbs_bund_zivile_flugplaetze,kbs_bund_oeffentlicher_verkehr,kbs_bund_militaer,av_wms_resf,av_wms_osbp&E=2710714.52&N=1269007.42&layers_visibility=true,true,true,true,true,true,true,false,true",
        notes: ""
    },
    {
        kuerzel: "ur",
        name: "Uri",
        wappen: "wappen/ur.gif",
        link: "https://geo.ur.ch/?basemap=AVGRAU&center=968458%2C5906587&layers=Kataster%20der%20belasteten%20Standorte&opacity=1&visibility=true&zoom=12",
        notes: ""
    },
    {
        kuerzel: "vd",
        name: "Waadt",
        wappen: "wappen/vd.gif",
        link: "https://www.geo.vd.ch/?&mapresources=GEOVD_EAUX,GEOVD_DONNEESBASE",
        notes: "Im linken Fenster: Lacs et cours d'eau sowie Protection des Eaux abwählen und Catastre des sites pollués anwählen"
    },
    {
        kuerzel: "vs",
        name: "Wallis",
        wappen: "wappen/vs.gif",
        link: "https://sitonline.vs.ch/environnement/sites_pollues/#/?lang=de&layers=WMTS_7958,t,0.51;VectorTile_6461,t,1;geolocation,t,1;Communes_8487,t,1;MO_4064,t,1;sites_pollues_surface_7123,t,1;sites_pollues_surface_8860,t,1;sites_pollues_7292,t,1;draw-layer,t,1&E=2612148&N=1121655&scale=387504&wkid=2056",
        notes: ""
    },
    {
        kuerzel: "zg",
        name: "Zug",
        wappen: "wappen/zg.gif",
        link: "https://www.zugmap.ch/bmcl/legend?project=ZugMap.ch&legend=alle%20Themen&rotation=0.00&scale=90069&center=2685830,1222810&layers=22481970-e352-46bd-aaea-9f75a78052e5&link=kbs",
        notes: ""
    },
    {
        kuerzel: "zh",
        name: "Zürich",
        wappen: "wappen/zh.gif",
        link: "https://maps.zh.ch/?topic=AwelKBSZH",
        notes: ""
    }
];

export default class extends React.Component{
    render() {
        return (
            <Page title="KbS" large>
                <IonList>
                    {kbslist.map(e => 
                        <IonItem key={e.kuerzel}>
                            <img src={e.wappen} style={{width: 30, marginRight: 10}}/>
                            <IonLabel>
                                <h2>{e.name}</h2>
                                <a href={e.link} target="_blank">{e.link.replace("https://","")}</a>
                                <IonLabel textWrap>
                                    <p textWrap><i>{e.notes}</i></p>
                                </IonLabel>
                            </IonLabel> 

                        </IonItem>)}
                </IonList>
            </Page>
        )
    }
}